import createRequest from "@/utils/request"

/**
 * 公司主体列表
 */
const getCorporateList = (payload: any) =>
    createRequest("SDL_URL").get("/corporate/list", {
        params: payload
    })

/**
 * 新增公司主体
 */
const createCorporate = (payload: any) =>
    createRequest("SDL_URL").post("/corporate/create", payload)

/**
 * 编辑公司主体
 */
const updateCorporate = (payload: any) =>
    createRequest("SDL_URL").post("/corporate/update", payload)

/**
 * 公司主体启用/禁用
 */
const corporateEnableOrDisable = (payload: any) =>
    createRequest("SDL_URL").post("/corporate/enable-or-disable", payload)

export default {
    getCorporateList,
    createCorporate,
    updateCorporate,
    corporateEnableOrDisable
}
